import { Link } from "react-router-dom";
import type { ArticleItem } from "@/types/content";
import { formatDate, formatViews } from "@/utils/content";

export default function ArticleCard({ article }: { article: ArticleItem }) {
  return (
    <Link
      to={`/articles/detail/${article.id}`}
      className="group flex w-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-accent-300"
    >
      <div className="relative aspect-[16/10] w-full overflow-hidden bg-background-200">
        <img
          src={article.cover}
          alt={`${article.title}的配图`}
          title={`${article.title} - 趣味文章`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
        />
        <span className="absolute left-3 top-3 rounded-md bg-accent-500 px-2 py-1 text-[11px] font-medium text-background-50">
          {article.tag}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-4 md:p-5">
        <h3 className="line-clamp-2-custom text-base font-medium leading-relaxed text-foreground-950">
          {article.title}
        </h3>
        <p className="line-clamp-3-custom text-xs leading-relaxed text-foreground-600 md:text-sm">
          {article.excerpt}
        </p>
        <div className="mt-auto flex flex-wrap items-center gap-x-3 gap-y-1 pt-1 text-xs text-foreground-500">
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-quill-pen-line"></i>
            {article.author}
          </span>
          <span className="whitespace-nowrap">{formatDate(article.date)}</span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-eye-line"></i>
            {formatViews(article.views)}
          </span>
          <span className="whitespace-nowrap text-foreground-400">
            {article.readMinutes} 分钟阅读
          </span>
        </div>
      </div>
    </Link>
  );
}